var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showSearchResults
    ? _c(
        "div",
        { staticClass: "navbar__search-results" },
        [
          _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
            _vm.showSearchSuggestions
              ? _c(
                  "ul",
                  {
                    key: "suggestions",
                    staticClass: "navbar__search-results__suggestions",
                  },
                  [
                    _c(
                      "li",
                      {
                        staticClass:
                          "navbar__search-results__suggestions__title",
                      },
                      [_vm._v("Suggested Search Terms")]
                    ),
                    _vm._l(_vm.searchResults, function (suggestion) {
                      return _c(
                        "li",
                        {
                          key: suggestion,
                          staticClass:
                            "navbar__search-results__suggestions__item",
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "tab",
                                      9,
                                      $event.key,
                                      "Tab"
                                    )
                                  )
                                    return null
                                  return _vm.tabOut(suggestion)
                                },
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.$emit("selected", suggestion)
                                },
                              },
                            },
                            [_vm._v(_vm._s(suggestion))]
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                )
              : _vm.search.length > 0
              ? _c(
                  "div",
                  {
                    key: "results",
                    staticClass: "navbar__search-results__results",
                  },
                  [
                    _c(
                      "p",
                      { staticClass: "navbar__search-results__results__title" },
                      [
                        _vm._v(
                          "Suggested Products " + _vm._s(_vm.searchResultsCount)
                        ),
                        _c("a", { attrs: { href: _vm.getSearchURL } }, [
                          _vm._v("See All"),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "navbar__search-results__results__products",
                      },
                      _vm._l(_vm.searchResults.slice(0, 3), function (product) {
                        return _c(
                          "div",
                          {
                            key: product.id,
                            staticClass:
                              "navbar__search-results__results__item",
                          },
                          [
                            _c("product-tile", {
                              attrs: { product: product, horizontal: true },
                            }),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }